const getters = {
    token: state => state.admin.token,
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    info: state => state.admin.info,
    dialogFullscreen: state => state.app.dialogFullscreen,
    labelPosition: state => state.app.labelPosition,
};
export default getters
